import {
	Container,
	ContainerPadding,
	CTA,
	Text,
	TextAlignment,
	TokenTextAppearance,
	TokenTextColor,
} from '@volkswagen-onehub/components-core';
import { PriceTypeSwitch } from '@volkswagen-onehub/icons-core';
import React from 'react';
import styled from 'styled-components';
import { VehicleInfoContainer } from './vehicle-selected-styles';

interface VehicleInfoProps {
	title: string;
	isNew: boolean;

	motorization?: string;
	hasCta?: boolean;
	onCtaClick?: () => void;
}

const BalancedText = styled(Text)`
	text-wrap: balance;
`;

export const VehicleInfo = (props: VehicleInfoProps) => {
	const { title, isNew, motorization, hasCta, onCtaClick } = props;

	return (
		<VehicleInfoContainer
			horizontalAlign={'center'}
			verticalAlign={'center'}
			wrap={'always'}
			stretchContent
			data-testid="vehicle-info-container"
		>
			<BalancedText
				appearance={TokenTextAppearance.headline400}
				color={TokenTextColor.primary}
				textAlign={TextAlignment.center}
				bold
			>
				{Boolean(isNew) && 'Nuevo' + ' '}
				{title}
			</BalancedText>

			{motorization && (
				<Container padding={{ top: ContainerPadding.static200 }} horizontalAlign={'center'} stretchContent>
					<Text appearance={TokenTextAppearance.copy200} color={TokenTextColor.secondary}>
						{motorization}
					</Text>
				</Container>
			)}

			{hasCta && (
				<Container padding={{ top: ContainerPadding.static300 }} horizontalAlign={'center'} stretchContent>
					<CTA
						emphasis="secondary"
						size="small"
						type="button"
						tag="button"
						icon={<PriceTypeSwitch variant="small" />}
						onClick={onCtaClick}
					>
						Cambiar selección
					</CTA>
				</Container>
			)}
		</VehicleInfoContainer>
	);
};
